export default __webpack_public_path__ + "static/media/bnr2.d5ca5cb1.jpg";